<template>
    <main v-if="!loading && post" class="lg:p-12 bg-gray-100 rounded p-4">
        <h2
            class="text-3xl font-bold text-center text-themeColor mb-4 break-words"
        >
            {{ post.reference }} - {{ post.title }}
        </h2>
        <div>
            <p class="text-sm text-center font-medium text-gray-500">
                Créé {{ moment(post.created_at).fromNow() }},

                <time :datetime="post.created_at">
                    {{ moment(post.created_at).format('L') }}
                </time>
            </p>
        </div>
        <div
            class="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 xl:max-w-7xl xl:grid-flow-col-dense xl:grid-cols-3"
        >
            <section class="space-y-6 lg:col-start-1 lg:col-span-3">
                <PostMessages
                    :post="post"
                    :isConnected="isConnected"
                    :isIdentified="weakConnection"
                />
            </section>
            <section class="space-y-6 lg:col-start-1 lg:col-span-3">
                <PostAnswers
                    :post="post"
                    :isConnected="isConnected"
                    :isIdentified="weakConnection"
                />
            </section>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PostAnswers from '@/components/Model/Post/PostAnswers'
import PostMessages from '@/components/Model/Post/PostMessages'

export default {
    name: 'Post',
    components: { PostAnswers, PostMessages },
    data() {
        return {
            loading: true
        }
    },
    computed: {
        ...mapState('post', {
            post: (state) => state.postView
        }),
        ...mapState('auth', {
            user: (state) => state.user,
            isConnected: (state) => state.isConnected,
            weakConnection: (state) => state.weakConnection
        })
    },
    created() {
        let id = this.$route.params.id
        let key = this.$route.params.key
        if (key) {
            this.doGetPostbyKey(key)
        } else if (id) {
            this.doGetPost(id)
        }
    },
    methods: {
        ...mapActions('post', ['getPost', 'getPostByToken', 'getPostByKey']),
        doGetPostbyKey: function (key) {
            this.getPostByKey(key)
                .catch(() => {
                    this.$router.push('/404')
                })
                .finally(() => {
                    this.loading = false
                })
        },
        doGetPost: function (id) {
            var endpoint
            if (this.isConnected) {
                endpoint = this.getPost(id).then((response) => {
                    return this.getPost(id)
                })
            } else if (this.weakConnection) {
                endpoint = this.getPostByToken(id).then((response) => {
                    return this.getPostByToken(id)
                })
            } else {
                this.$router.push('/404')
            }
            endpoint
                .catch((e) => {
                    this.$store.dispatch('toastError', e)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
